import * as t from 'io-ts'

export function createEnumCodec<T extends Record<string, string | number>>(e: T) {
    const isEnumValue = (input: any): input is T[keyof T] => Object.values(e).includes(input);
    return new t.Type<T[keyof T], T[keyof T], unknown>(
        'enum',
        isEnumValue,
        (input, context) => (isEnumValue(input) ? t.success(input) : t.failure(input, context)),
        t.identity
    );
}